/* tslint:disable */

declare var Object: any;
export interface CfdiInterface {
  "data": any;
  "fechaTimbrado": Date;
  "id"?: any;
}

export class Cfdi implements CfdiInterface {
  "data": any;
  "fechaTimbrado": Date;
  "id": any;
  constructor(data?: CfdiInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Cfdi`.
   */
  public static getModelName() {
    return "Cfdi";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Cfdi for dynamic purposes.
  **/
  public static factory(data: CfdiInterface): Cfdi{
    return new Cfdi(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Cfdi',
      plural: 'Cfdis',
      path: 'Cfdis',
      idName: 'id',
      properties: {
        "data": {
          name: 'data',
          type: 'any'
        },
        "fechaTimbrado": {
          name: 'fechaTimbrado',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
